export enum YMGoals {
  USER_LOGGED_IN_WITH_KEY = 'USER_LOGGED_IN_WITH_KEY',
  USER_LOGGED_IN_WITH_OTP = 'USER_LOGGED_IN_WITH_OTP',
  USER_AUTH_ERROR = 'USER_AUTH_ERROR',
  USER_LOGGED_OUT = 'USER_LOGGED_OUT',

  IFRAME_MODE = 'IFRAME_MODE',
  NO_IFRAME_MODE = 'NO_IFRAME_MODE',

  IS_MOBILE = 'IS_MOBILE',
  NO_MOBILE = 'NO_MOBILE',

  USER_ID_CHANGED = 'USER_ID_CHANGED',

  PHONE_CONFIRMATION_INIT = 'PHONE_CONFIRMATION_INIT',
  PHONE_CONFIRMATION_FINISHED = 'PHONE_CONFIRMATION_FINISHED',

  PHONE_CONFIRMATION_TIMEOUT_CODE = 'PHONE_CONFIRMATION_TIMEOUT_CODE',
  PHONE_CONFIRMATION_CHANGE_TIMEOUT_SHOWN = 'PHONE_CONFIRMATION_CHANGE_TIMEOUT_SHOWN',

  VERIFICATION_INIT = 'VERIFICATION_INIT',
  VERIFICATION_PROFILE_FINISHED = 'VERIFICATION_PROFILE_FINISHED',
  VERIFICATION_DOCUMENTS_FINISHED = 'VERIFICATION_DOCUMENTS_FINISHED',

  VERIFICATION_INN_MANUAL_INIT = 'VERIFICATION_INN_MANUAL_INIT',
  VERIFICATION_INN_MANUAL_SUCCESS = 'VERIFICATION_INN_MANUAL_SUCCESS',
  VERIFICATION_INN_MANUAL_ERROR = 'VERIFICATION_INN_MANUAL_ERROR',

  VERIFICATION_INN_AUTO_SUCCESS = 'VERIFICATION_INN_AUTO_SUCCESS',

  VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS',
  VERIFICATION_ERROR = 'VERIFICATION_ERROR',

  INVOICE_INIT = 'INVOICE_INIT',
  INVOICE_EXPIRED = 'INVOICE_EXPIRED',
  INVOICE_SUCCESS = 'INVOICE_SUCCESS',
  INVOICE_ERROR = 'INVOICE_ERROR',

  WITHDRAWAL_PHONE_SET = 'WITHDRAWAL_PHONE_SET',
  WITHDRAWAL_PREPARE = 'WITHDRAWAL_PREPARE',
  WITHDRAWAL_TRANSFER = 'WITHDRAWAL_TRANSFER',
  WITHDRAWAL_SUCCESS = 'WITHDRAWAL_SUCCESS',
  WITHDRAWAL_ERROR = 'WITHDRAWAL_ERROR',

  WITHDRAWAL_TIMEOUT = 'WITHDRAWAL_TIMEOUT',
}

const ymId = window.env.YM_ENABLED === 'true' && window.env.YM_ID ? window.env.YM_ID : undefined;

const goalReachedFunc = (id: number) => (goalName: YMGoals) => {
  try {
    ym(id, 'reachGoal', goalName);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(goalName, e);
  }
};

export const goalReached = ymId
  ? goalReachedFunc(ymId)
  : () => {
      /* noop */
    };
